// BarChart.jsx
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
  } from "chart.js";
  
  import { Bar } from "react-chartjs-2";
  
  // Register required components
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
  
  const BarChart = ({ barChartData }) => {
	const options = {
	  responsive: true,
	  plugins: {
		legend: { position: "top" },
		title: { display: true, text: "Chart.js Bar Chart" },
	  },
	};
  
	return <Bar options={options} data={barChartData} />;
  };
  
  export default BarChart;
  